var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 4.75H7.25L7.5441 3.8676C7.8164 3.0509 8.5806 2.5 9.4415 2.5H14.5584C15.4193 2.5 16.1835 3.0508 16.4558 3.8676L16.7499 4.75H20.9999C21.414 4.75 21.7499 5.0859 21.7499 5.5C21.7499 5.9141 21.414 6.25 20.9999 6.25H3C2.5859 6.25 2.25 5.9141 2.25 5.5C2.25 5.0859 2.5859 4.75 3 4.75ZM18 22.5H6C4.8954 22.5 4 21.6046 4 20.5V7.5H20V20.5C20 21.6046 19.1046 22.5 18 22.5ZM8.75 9.5C8.75 9.0859 8.4141 8.75 8 8.75C7.5859 8.75 7.25 9.0859 7.25 9.5V18.5C7.25 18.9141 7.5859 19.25 8 19.25C8.4141 19.25 8.75 18.9141 8.75 18.5V9.5ZM12.75 9.5C12.75 9.0859 12.4141 8.75 12 8.75C11.5859 8.75 11.25 9.0859 11.25 9.5V18.5C11.25 18.9141 11.5859 19.25 12 19.25C12.4141 19.25 12.75 18.9141 12.75 18.5V9.5ZM16.75 9.5C16.75 9.0859 16.4141 8.75 16 8.75C15.5859 8.75 15.25 9.0859 15.25 9.5V18.5C15.25 18.9141 15.5859 19.25 16 19.25C16.4141 19.25 16.75 18.9141 16.75 18.5V9.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.054a5580f349351f4231293069d20c28.svg";
export { ForwardRef as ReactComponent };